import { firestore } from "../../firebase/config";
import { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import TournamentCard from "../home/components/TournamentCard";

const MyTournaments = ({ user }) => {
  const [tournaments, setTournaments] = useState([]);

  useEffect(() => {
    if (!user?.uid) {
      return;
    }

    const fetchTournaments = async () => {
      const tournamentsRef = collection(firestore, "tournaments");

      const archivedTournamentsQuery = query(
        tournamentsRef,
        where("organizerUids", "array-contains", user.uid)
      );

      try {
        const collection = await getDocs(archivedTournamentsQuery);

        if (collection.docs) {
          const tournamentsList = collection.docs.map((doc) => ({
            id: doc.id, // Use the document ID if needed
            ...doc.data(),
          }));

          setTournaments(tournamentsList);
        } else {
          console.log("No tournaments!");
        }
      } catch (error) {
        console.error("Error fetching tournaments:", error);
      }
    };

    fetchTournaments();
  }, [user?.uid]);

  const sortTournaments = (a, b) => {
    return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
  };

  if (!tournaments) {
    return;
  }

  return (
    <div className="flex flex-col w-full justify-center">
      <div className="flex justify-center flex-wrap mt-4">
        {tournaments.sort(sortTournaments).map((tournament) => (
          <TournamentCard
            key={tournament.id}
            id={tournament.id}
            tournament={tournament}
            isUserOrganizer={tournament.organizerUids.includes(user?.uid)}
          />
        ))}
      </div>
    </div>
  );
};

export default MyTournaments;
